<div mat-dialog-title>
    <h3 class="text-primary-500 text-2xl font-bold">Media Terms & Conditions</h3>
</div>
<div mat-dialog-content>

    <p class="text-primary-300 text-sm mb-2">
        At AtChurch, our mission is to take the Scripture to far reaches of the Earth. We want to be a platform that
        enables a diverse range of voices and perspectives to share Christ oriented teaching, stories, learnings,
        thoughts, testimonies with the world.,
    </p>

    <p class="text-primary-300 text-sm mb-2">
        However, that doesn’t mean anything goes on the platform.</p>

    <p class="text-primary-300 text-sm mb-2">
        Below is a list of guidelines for creating content on AtChurch, to ensure that everyone has a safe and enjoyable
        experience. We reserve the right to remove any content we think violates our guidelines, the AtChurch Platform
        Rules, or our Terms of Service. Also, bear in mind that as we grow, our policies may change.</p>

    <p class="text-primary-500 font-semibold mb-1">Hateful content</p>
    <p class="text-primary-300 text-sm mb-2">
        We don’t permit content that incites violence or hatred towards an individual or group based on race, religion,
        gender identity or expression, sex, ethnicity, nationality, sexual orientation, veteran status, age, or
        disability or other characteristics associated with systemic discrimination or marginalization.</p>

    <p class="text-primary-300 text-sm mb-2">Examples of what to avoid include:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">Promoting violence against individuals or groups based on the
            characteristics listed above</li>
        <li class="text-primary-300 text-sm mb-2">Encouraging others to believe that a person or group is inhuman or
            worthy of being hated based on the characteristics listed above</li>
        <li class="text-primary-300 text-sm mb-2">Glorifying images and symbols associated with hate groups</li>
        <li class="text-primary-300 text-sm mb-2">Claims that a group is predisposed to committing offline harm</li>
    </ul>
    <p class="text-primary-500 font-semibold mb-1">Promoting supremacist beliefs
    </p>
    <p class="text-primary-300 text-sm mb-2">
        Promoting revisionist theories about acts of genocide</p>
    <p class="text-primary-500 font-semibold mb-1">Dangerous content
    </p>
    <p class="text-primary-300 text-sm mb-2">
        We Don’t encourage others to do anything that could put themselves or anyone else in serious physical harm. This
        includes, but isn’t limited to, dangerous challenges or acts of suicide and/or self-harm.</p>
    <p class="text-primary-500 font-semibold mb-1">Violent or graphic content
    </p>
    <p class="text-primary-300 text-sm mb-2">
        We don’t allow content that features graphic or gratuitous depictions of violence, gore, or other shocking
        elements.</p>
    <p class="text-primary-300 text-sm mb-2">Examples of what to avoid include:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">Depictions of graphic acts of violence or abuse</li>
        <li class="text-primary-300 text-sm mb-2">
            Gruesome depictions of serious physical injury or trauma</li>
    </ul>
    <p class="text-primary-500 font-semibold mb-1">Harassment or cyberbullying
    </p>
    <p class="text-primary-300 text-sm mb-2">
        We don’t allow harassment on AtChurch. Examples include:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">
            Sharing, threatening to share, or encouraging others to share someone’s private information without their
            consent</li>
        <li class="text-primary-300 text-sm mb-2">
            Repeatedly targeting someone with unwanted sexual advances</li>
    </ul>

    <p class="text-primary-500 font-semibold mb-1">Sexually explicit content
    </p>
    <p class="text-primary-300 text-sm mb-2">
        You should avoid content that contains sexually explicit material such as:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">
            Pornography and other similar graphic depictions of sexual acts for the purpose of sexual gratification</li>
        <li class="text-primary-300 text-sm mb-2">
            Depictions or descriptions of genitalia or nudity presented for the purpose of sexual gratification</li>
        <li class="text-primary-300 text-sm mb-2">
            Advocating or glorifying sexual themes related to rape, incest, or beastiality</li>
    </ul>
    <p class="text-primary-500 font-semibold mb-1">Infringing content
    </p>
    <p class="text-primary-300 text-sm mb-2">
        We protect creators’ intellectual property so they can be fairly compensated for their work. Any content that is
        provided to AtChurch without rightsholder permission may be removed. The same is true for content that infringes
        upon the trademarks of others. If you use samples in your music, make sure they are cleared with the owner
        first.</p>
    <p class="text-primary-500 font-semibold mb-1">Illegal content</p>
    <p class="text-primary-300 text-sm mb-2">
        We require content providers to comply with applicable laws and regulations, including those governing content
        administered by the U.S. Office of Foreign Assets Control (“OFAC”) and the German ​Bundesprüfstelle für
        jugendgefährdende Medien (“BPjM”). Any content in violation of local laws may be removed, and we may withhold
        related payments if that content is subject to sanctions.</p>
    <p class="text-primary-500 font-semibold mb-1">Impersonation</p>
    <p class="text-primary-300 text-sm mb-2">
        Avoid content that impersonates others in a way that is intended or likely to deceive. This includes posing as
        or mimicking another person, or misrepresenting your affiliation with a person, brand, or organization.</p>
    <p class="text-primary-500 font-semibold mb-1">Spam</p>
    <p class="text-primary-300 text-sm mb-2">
        We don’t allow any kind of spam on AtChurch. Spam includes, but isn’t limited to:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">
            Content made solely to improve SEO or promote a product or service</li>
        <li class="text-primary-300 text-sm mb-2">
            Mass publishing identical or indistinguishable content that directs listeners to potentially harmful sites
            or
            services, or violates our monetization policies</li>
    </ul>
    <p class="text-primary-500 font-semibold mb-1">Monetization fraud
    </p>
    <p class="text-primary-300 text-sm mb-2">
        Using our monetization features fraudulently may result in monetization bans, account removals, and platform
        bans.</p>
    <p class="text-primary-300 text-sm mb-2">Monetization fraud includes, but isn t limited to:</p>
    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">
            Using credit cards you don’t own to generate fraudulent Listener Support earnings</li>
        <li class="text-primary-300 text-sm mb-2">
            Inflating play counts to increase ad impressions and generate fraudulent earnings</li>
        <li class="text-primary-300 text-sm mb-2">
            Enlisting a third party to generate inauthentic Listener Support or Paid Subscriptions earnings</li>
    </ul>
    <p class="text-primary-500 font-semibold mb-1">Enforcement</p>
    <p class="text-primary-300 text-sm mb-2">
        You can report content you think violates these guidelines by contacting us directly. Once we’ve received your
        report, we’ll review the content and take action if we find any violations. For claims against content you
        believe infringes your intellectual property rights, please visit this page.</p>
    <p class="text-primary-300 text-sm mb-2">
        Repeated violations of our prohibited content policies can result in losing access to the AtChurch platform.)
</div>
<div mat-dialog-actions class="flex flex-row justify-end w-full">
    <button mat-button
        class="bg-primary-500 text-white hover:bg-primary-700 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
        (click)="ok()" cdkFocusInitial>Okay</button>
</div>